import { palette } from './designTokens';
import { formatSignalLabelFromKey, getSignalVariant } from './signalUtils';

// Name-based color mapping (current behavior baseline).
// We can later replace/extend this with severity/priority-driven mapping.
const NAME_COLOR_MAP = {
  'wrong context': palette.status.warning,
  'frustrated': palette.status.warning,
  'ungrounded': palette.accents.primary.base,
  'jailbreaking': palette.status.danger,
  'data leak': palette.accents.warm.base,
  'pii leakage': palette.accents.warm.base,
};

const normalize = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');

export const getSignalColorFromDefinition = (definition = {}) => {
  const key = definition.metric_name || definition.classifier_type || definition.classifier_key;
  const resolvedName = normalize(
    definition.name
    || definition.display_name
    || formatSignalLabelFromKey(key)
    || ''
  );

  if (resolvedName && NAME_COLOR_MAP[resolvedName]) {
    return NAME_COLOR_MAP[resolvedName];
  }

  const variant = getSignalVariant(definition.polarity, key);
  if (variant === 'info') return palette.status.success;
  if (variant === 'danger') return palette.status.danger;
  if (variant === 'warning') return palette.status.warning;
  return palette.accents.primary.base;
};
